<template>
<standard-dialog v-model="visible" :width="240" scrollable persistent>

  <template slot="title">
    <span class="title">{{$t('device.control_device')}}</span>
  </template>

  <v-layout row wrap>
    <v-flex xs12 v-for="c in controls" :key="c.key" class="py-1">
      <v-btn outline round block :color="c.color" @click="setControl(c.value)">{{ c.title }}</v-btn>
    </v-flex>
  </v-layout>

</standard-dialog>
</template>

<script>
import Dialog from '@/components/utils/Dialog'

export default {
  name: 'DeviceItemDialog',
  components: {
    'standard-dialog': Dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    isSwitch() {
      return [23, 28].includes(this.item.ctrltype);
    },
    isLevel() {
      return [24, 26, 41].includes(this.item.ctrltype);
    },
    isDoorlock() {
      return [31].includes(this.item.ctrltype);
    },
    isThermostatFan() {
      return [32].includes(this.item.ctrltype);
    },
    isThermostatMode() {
      return [33].includes(this.item.ctrltype);
    },
    isThermostatTemperature() {
      return [34].includes(this.item.ctrltype);
    },
    isSiren() {
      return [25].includes(this.item.ctrltype);
    },
    controls() {
      if (this.isSwitch) return this.controlsSwitch;
      if (this.isLevel) return this.controlsLevel;
      if (this.isDoorlock) return this.controlsDoorlock;
      if (this.isThermostatFan) return this.controlsThermostatFan;
      if (this.isThermostatMode) return this.controlsThermostatMode;
      if (this.isThermostatTemperature) return this.controlsThermostatTemperature;
      if (this.isSiren) return this.controlsSiren;
    },
    controlsSwitch() {
      return [255, 0].map(v => ({
        key: `switch_${v}`,
        title: this.$t(`device.switch_${v}`),
        color: 'primary',
        value: v
      }));
    },
    controlsLevel() {
      return [100, 75, 50, 25, 0].map(v => ({
        key: `level_${v}`,
        title: this.$t(`device.level_${v}`),
        color: 'primary',
        value: Math.min(99, v)
      }));
    },
    controlsDoorlock() {
      return [255, 0].map(v => ({
        key: `lock_${v}`,
        title: this.$t(`device.lock_${v}`),
        color: 'primary',
        value: v
      }));
    },
    controlsThermostatFan() {
      return ['fan_off', 'fan_auto_low', 'fan_low', 'fan_auto_high', 'fan_high'].map((v, i) => ({
        key: `thermostat_${v}`,
        title: this.$t(`device.${v}`),
        color: 'primary',
        value: i
      }));
    },
    controlsThermostatMode() {
      return ['mode_off', 'mode_heat', 'mode_cool', 'mode_auto'].map((v, i) => ({
        key: `thermostat_${v}`,
        title: this.$t(`device.${v}`),
        color: 'primary',
        value: i
      }));
    },
    controlsThermostatTemperature() {
      let c = [23, 24, 25, 26, 27, 28, 29, 30];
      let f = [72, 74, 76, 78, 80, 82, 84, 86];
      let u = this.item.unit == 1 ? c : f;
      let l = this.item.unit == 1 ? '°C' : '°F';
      return u.map((v, i) => ({
        key: `thermostat_${v}`,
        title: `${v}${l}`,
        color: 'primary',
        value: v
      }));
    },
    controlsSiren() {
      return ['siren_off', 'siren_fire', 'siren_ambulance', 'siren_police', 'siren_alarm', 'siren_ding_dong', 'siren_beep'].map((v, i) => ({
        key: `siren_${v}`,
        title: this.$t(`device.${v}`),
        color: 'primary',
        value: i
      }));
    }
  },
  methods: {
    setControl(value) {
      this.$emit('control', this.item, value);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceActionDialog.vue